import Grid from '@material-ui/core/Grid';
import Typography from 'components/CncUI/Typography';
import DataTable from 'components/CncUI/DataTable';
import BankStatus from 'pages/Profile/DirectDeposit/Plaid/BankAccounts/BankStatus';

const Banks = props => {
  const { banks } = props;

  const columns = [
    { field: 'name', label: 'Bank Name' },
    { field: 'status', label: 'Bank Status', sortable: false },
    { field: 'description', sortable: false },
  ];

  const parseStatus = item => <BankStatus bank={item} />;
  const parseDescription = item => {
    switch (item.status) {
      case 'completed':
      case 'verified':
        return 'The bank is verified and ready to be used and get accounts information.';
      case 'pending':
        return 'Plaid services needs to verify this bank and Mycnc will notify the user when the bank gets verified or rejected.';
      case 'pending_manual':
        return 'This bank is waiting for user verification with 2 micro-deposits information in the provided account.';
      case 'expired':
        return 'This bank has been rejected because Plaid could not verify it and it needs to be deleted';
      default:
        return `This bank status is unknown: ${item.status}.`;
    }
  };

  const rows = banks.map(item => ({
    name: item.name,
    status: parseStatus(item),
    description: parseDescription(item),
  }));

  return (
    <Grid container spacing={0}>
      <Grid item xs={12}>
        <Typography variant="h5">Banks</Typography>
      </Grid>
      <Grid item xs={12}>
        <DataTable
          transparent
          data={rows}
          columns={columns}
          pagination={false}
          emptyRows="No banks information to display"
        />
      </Grid>
    </Grid>
  );
};

export default Banks;
